<template>
	<sky-suffix v-bind="$attrs" @search-click="search">
		<el-select
			@change="handleChange"
			@clear="clear"
			@focus="focus"
			@blur="blur"
			:value="selected"
			v-bind="$attrs"
			:value-key="valueKey"
			:placeholder="placeholder || '请选择'"
			:multiple="multiple || false"
			filterable
			:clearable="clearable"
			:disabled="disabled"
			:size="size"
			:style="[inputStyle]"
		>
			<el-option
				v-for="(item, index) in option"
				:key="item[props.value]"
				:label="_setOptionLeftLabel(item)"
				:value="item[props.value]"
				:disabled="onDisabledOption(item)"
			>
				<div v-if="customOption">
					<span style="float: left">{{ _setOptionLeftLabel(item) }}</span>
					<span style="float: right; margin: 0 20px; color: #8492a6; font-size: 13px">{{
						_setOptionValue(item, index)
					}}</span>
				</div>
			</el-option>
			<slot name="prefix" slot="prefix" v-if="$slots.prefix"></slot>
		</el-select>
		<slot name="toolTips" slot="toolTips"></slot>
	</sky-suffix>
</template>
<script>
import SkySuffix from '../formComponents/SkySuffix.vue';
import formStore from '@/mixins/formStore.js';
import { getDict } from '@/backend/services/dictionary/dictionary';
export default {
	name: 'sky-select',
	mixins: [formStore],
	componentName: 'sky-select',
	components: {
		SkySuffix,
	},
	props: {
		placeholder: String,
		customOption: {
			default: () => false,
		},
		setOptionValue: Function,
    setOptionLeftLabel: Function,
		value: {
			default: null,
			required: true,
		},
		options: [Array, String, Function, Object, Promise],
		props: {
			default() {
				return {
					label: 'label',
					value: 'value',
				};
			},
		},
		dict: {
			required: false,
		},
		multiple: {
			default: false,
		},
		clearable: {
			type: Boolean,
			default: true,
		},
		size: String,
		valueKey: String,
		disabled: Boolean,
		disabledOption: [Boolean, Function],
		inputStyle: {
			type: Object,
			default() {
				return {
					width: '100%',
				};
			},
		},
	},
	created() {},
	data() {
		return {
			selected: this.value,
			value3: '',
			option: [],
		};
	},
	watch: {
		value: {
			handler: function (val) {
				this.selected = val;
			},
			immediate: true,
		},
		options: {
			handler: function (val) {
				//判断options是否为promise
				if (typeof val !== 'function' && val && !val.then) {
					this.option = this.options;
				}
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		onDisabledOption(item) {
			if (typeof this.disabledOption == 'boolean') {
				return this.disabledOption;
			} else if (typeof this.disabledOption == 'function') {
				return this.disabledOption(item);
			} else {
				return this.disabled;
			}
		},
		search(e) {
			this.$emit('search-click', e);
		},
		handleChange(val) {
			this.selfData = val;
			!this.delay && this.setVal();
			this.$emit('change', val);
		},
		clear() {
			this.selected = '';
			this.$emit('clear');
		},
		focus(e) {
			this.$emit('focus', e);
		},
		blur(e) {
			this.$emit('blur', e);
		},
		_setOptionValue(item, index) {
			if (!this.setOptionValue) return item[this.props.value];
			return this.setOptionValue(item, index);
		},
    _setOptionLeftLabel(item){
      if (!this.setOptionLeftLabel) return item[this.props.label];
			return this.setOptionLeftLabel(item);
    }
	},
	mounted() {
		if (!Array.isArray(this.options) && this.options) {
			this.options().then(val => {
				this.option = val.data || val;
			});
		} else if (this.dict) {
			getDict(this.dict).then(val => {
				this.option = val.data;
			});
		} else {
			this.option = this.options;
		}
	},
};
</script>
<style scoped lang="scss">
.el-select {
	width: 100%;
}
</style>
